import { CurrencyPipe, NgTemplateOutlet } from '@angular/common';
import { booleanAttribute, Component, computed, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NumberInputComponent } from '../../form/number-input';
import { PillCellComponent, PillRowComponent } from '../../pill-table';
import { ApplicationDetailDashboardBoxComponent } from '../application-detail-dashboard-box/application-detail-dashboard-box.component';
import { SimpleBaseEffectiveControlComponent } from '../simple-base-effective-control.component';

@Component({
    selector: 'tran-application-detail-approved-budget',
    templateUrl: './application-detail-approved-budget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CurrencyPipe,
        NgTemplateOutlet,
        ApplicationDetailDashboardBoxComponent,
        NumberInputComponent,
        TranslatePipe,
        ReactiveFormsModule,
        PillCellComponent,
        PillRowComponent
    ]
})
export class ApplicationDetailApprovedBudgetComponent extends SimpleBaseEffectiveControlComponent<number | null> {
    public readonly showFundingRatio = input(false, { transform: booleanAttribute });
    public readonly fundingRatio = input<number | null>(null);
    public readonly allFundingRatios = input<number[]>([]);
    public readonly fundingRatioControl = input<FormControl<number | null>>();

    protected readonly fundingRatioLocalControl = new FormControl<number | null>(null);
    protected readonly fundingRatioEffectiveControl = computed(
        () => this.fundingRatioControl() ?? this.fundingRatioLocalControl
    );

    constructor() {
        super();
        effect(() => this.fundingRatioEffectiveControl().patchValue(this.fundingRatio()));
    }
}
